/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Few_Stale_Spider_EvokeInputs */

const fr_few_stale_spider_evoke = /** @type {(inputs: Few_Stale_Spider_EvokeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment installer`)
};

/**

* @param {Few_Stale_Spider_EvokeInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const few_stale_spider_evoke = /** @type {((inputs?: Few_Stale_Spider_EvokeInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Few_Stale_Spider_EvokeInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_few_stale_spider_evoke(inputs)
});